import { ImageSubject } from "../clients/data-service";
import { GroupBy } from "./DataTools";
import LocalId from "./LocalId";

export class PersonPosition
{
    row: number;
    column: number;
}

export class DraftImageSubject extends PersonPosition
{
    readonly id: string;
    row: number;
    column: number;
    name?: string;
    role?: string;

    constructor(row:number, column:number, role?:string) {
        super();
        this.id = LocalId.next();
        this.row = row;
        this.column = column;
        this.role = role;
    }
}

export class ImageSubjectUtilities {
    static maxCol(subjects: Array<DraftImageSubject>, rowIndex: number) : number {
        let max = 0;
        subjects.filter(s => s.row === rowIndex).forEach(p => {
            if (p.column > max) {
                max = p.column;
            }
        });
        return max;
    }
    static getOrAdd(subjects: Array<DraftImageSubject>, pos:PersonPosition) : DraftImageSubject {
        var subject = subjects.find(s => s.row === pos.row && s.column === pos.column);
        if (subject == null) {
            subject = new DraftImageSubject(pos.row, pos.column);
            subjects.push(subject);
        }
        return subject;
    }

    static maxRow(subjects: Array<DraftImageSubject>) : number {
        let max = -10;
        subjects.forEach(p => {
            if (p.row > max) {
                max = p.row;
            }
        });

        return max;
    }

    static minRow(subjects: Array<DraftImageSubject>) : number {
        let min = 100;
        subjects.forEach(p => {
            if (p.row < min) {
                min = p.row;
            }
        });

        return min;
    }

    static fillGaps(subjects: Array<DraftImageSubject>) : void {
        // Fill any missing rows
        var maxRow = ImageSubjectUtilities.maxRow(subjects);
        for (var i = 1; i < maxRow; i++) {
            const row = i;
            if (subjects.filter(s => s.row === row).length === 0) {
                ImageSubjectUtilities.getOrAdd(subjects, {row:row, column:1});
            }
        }

        // Fill any gaps in rows
        var rows = Array.from(GroupBy(subjects, s=>s.row).keys());
        rows.forEach(row => {
            var max = ImageSubjectUtilities.maxCol(subjects, row);
            for (var i = 1; i <= max; i++) {
                ImageSubjectUtilities.getOrAdd(subjects, {row:row, column:i});
            }
        });
    }

    static draft(subjects: ImageSubject[]) : DraftImageSubject[] {
        return subjects.map(s => {
            const draft = new DraftImageSubject(s.row, s.column);
            draft.name = s.name;
            draft.role = s.role;
            return draft;
        });
    }

    static draftToSubmittableSubjects(drafts: DraftImageSubject[]) : ImageSubject[] {
        //const candidates = drafts.filter(d=> d.name != null);
        drafts.map(d => {
            if (d.name) {
                d.name = d.name.trim()
            }
        });
        const candidates = drafts;
        return candidates.map(d => ({row: d.row, column: d.column, name: d.name, role: d.role }));
    }
}